import React from 'react';
import { AreaChart, Area, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
    {
      
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
     
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
     
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
     
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];


  const Graph=()=>{
    return(
     <div>
     <div style={{height:"80px",width:"100%"}}>
     <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          width={500}
          height={400}
          data={data}
          
        >
          
         
          
          <Tooltip />
          <Area type="monotone" dataKey="uv" stroke=" rgba(5,50,200,10) " fill="rgba(0,212,250,1) " />
         
        </AreaChart>
      </ResponsiveContainer>
     </div>
     </div>
            
    );
  };
    
export default Graph;